var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationCircleFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0013 0.667969C3.95121 0.667969 0.667969 3.95121 0.667969 8.0013C0.667969 12.0514 3.95121 15.3346 8.0013 15.3346C12.0514 15.3346 15.3346 12.0514 15.3346 8.0013C15.3346 3.95121 12.0514 0.667969 8.0013 0.667969ZM8.0013 4.0013C7.63311 4.0013 7.33463 4.29978 7.33463 4.66797C7.33463 5.03616 7.63311 5.33463 8.0013 5.33463H8.00797C8.37616 5.33463 8.67463 5.03616 8.67463 4.66797C8.67463 4.29978 8.37616 4.0013 8.00797 4.0013H8.0013ZM8.66797 7.33463C8.66797 6.96644 8.36949 6.66797 8.0013 6.66797C7.63311 6.66797 7.33463 6.96644 7.33463 7.33463V11.3346C7.33463 11.7028 7.63311 12.0013 8.0013 12.0013C8.36949 12.0013 8.66797 11.7028 8.66797 11.3346V7.33463Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircleFilled);
export default __webpack_public_path__ + "static/media/exclamation-circle-filled.0aa2902e45ba5993ff6b3ed3a4bc749c.svg";
export { ForwardRef as ReactComponent };